import { EligibilityProrationTabs } from 'typings/enums';
import { EligibilityRuleTabView } from 'nomst/Stores/Budget/eligibilityRuleTabView';
import { ProrationRuleTabView } from
    'nomst/Stores/Budget/prorationRuleTabView';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import { setRulesTab, setRulesPanelView } from 'nomst/Actions/configurations';
import { observable, action, makeObservable } from 'mobx';


export class EligibilityProrationRuleView {
    @observable showEligibilityProrationRuleDialog: boolean;
    @observable currentRuleTab: Nullable<EligibilityProrationTabs>;
    @observable eligibilityRuleTabView: EligibilityRuleTabView;
    @observable prorationRuleTabView: ProrationRuleTabView;

    constructor(currentConfig: Configuration) {
        makeObservable(this);
        this.eligibilityRuleTabView = new EligibilityRuleTabView(currentConfig);
        this.prorationRuleTabView = new ProrationRuleTabView(currentConfig);
        this.showEligibilityProrationRuleDialog = false;
        this.currentRuleTab = null;
    }

    @action
    setShowEligiblityProrationRuleDialog(value: boolean): void {
        this.showEligibilityProrationRuleDialog = value;
    }

    isCurrentRuleTab(tab: EligibilityProrationTabs): boolean {
        return this.currentRuleTab === tab;
    }

    @action
    changeRuleTabLocal(tab: EligibilityProrationTabs): void {
        this.currentRuleTab = tab;
    }

    @action
    changeRuleTabGlobal(tab: EligibilityProrationTabs): void {
        this.currentRuleTab = tab;
        return setRulesTab(tab);
    }

    @action
    openRuleDialogLocal(): void {
        this.showEligibilityProrationRuleDialog = true;
        this.currentRuleTab = EligibilityProrationTabs.EligibilityRule;
    }

    @action
    openRuleDialogGlobal(): void {
        this.showEligibilityProrationRuleDialog = true;
        this.currentRuleTab = EligibilityProrationTabs.EligibilityRule;
        return setRulesPanelView(true);
    }

    @action
    closeRuleDialogLocal(): void {
        this.showEligibilityProrationRuleDialog = false;
        this.currentRuleTab = null;
    }

    @action
    closeRuleDialogGlobal(): void {
        this.showEligibilityProrationRuleDialog = false;
        this.currentRuleTab = null;
        return setRulesPanelView(false);
    }
}